import styled, { keyframes } from "styled-components";

const slideInRight = keyframes` 
   from {
     transform: translateX(100px);
   }
   to {
     transform: translateX(0px);
   }
 `;

export const Container = styled.div`
    height: 100vh;
    width: 100%;
    overflow:hidden;
    background:#fff;
`;

export const ScreenSection = styled.div`
height: 90%;
overflow-y: scroll;
padding: 10px;
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
    }
`;

export const VedioContainer = styled.div`
display: flex;
flex-wrap: wrap;
align-items: center;
justify-content: center;
padding-left: 5px;
height: 100%;
width:100%;
        // display: grid;
        //         grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        //         grid-template-columns: repeat(4,300px);
        //         grid-auto-flow: row dense;
        //         column-gap: 10px;
        //         row-gap: 15px;
        //         justify-content: center; 
        //         align-content: center;
`;
export const MessageBox = styled.div`
    width: 100%;
    height: 100%;
    /* chat_box */
    .chat_box {
        display: flex;
        flex-direction: column;
        height: 90%;
        width:100%;
    }
    
    /* body */
    .body {
        flex-grow: 1;
        overflow: hidden;
        overflow-y: auto;
        ::-webkit-scrollbar {
            width: 0;  /* Remove scrollbar space */
            background: transparent;  /* Optional: just make scrollbar invisible */
        }
    }
    .body .text {
        display: inline-block;
        padding: 10px;
        margin-bottom: 10px;
        border-radius: 15px;   
        .msg{
            margin:0 !important;
            padding:0 !important;
        }
        .profile-container{
            display: flex;
            align-items: baseline;
            .ant-avatar.ant-avatar-icon {
                font-size: 5px !important;
            }
        }
        .profile-user-name{
            font-size: 13px;
            font-weight: 600;
            margin-left: 10px;
            margin-bottom: 8px;
        }
    }
    .body .incoming {
        text-align: left;
    }
    .anticon svg {
        display: inline-block;
        font-size: 14px;
        margin-right: 2px;
        margin-bottom: 5px !important;
    }
    .body .outgoing {
        // animation: ${slideInRight} 0.8s ease-in-out 0s forwards;   
        text-align: right;
    }
    .body .outgoing .text{
        background: #f1f1f185;
    } 
    .body .incoming .text{
        background: #40d28e26;
    } 
    
`;

export const MessageButtonContainer = styled.div`
position: absolute;
 bottom: 20px;
 width: 90%;
 .progress-div{
    width: 100%;
     padding: 10px;
 }
 .msg-input-contrl-div{
    display: flex;
    align-items: baseline;
    .msg-container{
        width: 90%;
        position: relative;
        display: flex;
        align-items: center;
        border: 1px solid #b5b5b5;
        padding: 5px 10px;
        border-radius: 15px;
        input{
            width: 100%;
            font-size: 13px;
            font-family: 'Roboto', sans-serif;
            outline: none !important;
            border: none !important;
        }
    }
    .buttons-div{
        label{
            font-size: 18px;
            padding: 0 10px;
        }
        input{
            display:none;
        }
        .icons-div{
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 10px;
            .fa-icon{
                margin-right:  10px;
                font-size: 18px;
            }
        }
    }
 }
`;

export const CallControlWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const UserName = styled.p`
    position: absolute;
    left: 30px;
    color: white;
    font-size: 13px;
    bottom: 5px;
`;